"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RedErrorMessageBox;
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const useStyles = (0, mui_1.makeStyles)()(theme => ({
    bg: {
        padding: 4,
        margin: 4,
        overflow: 'auto',
        maxHeight: 200,
        background: theme.palette.mode === 'dark' ? '#833' : '#f88',
        border: `1px solid ${theme.palette.divider}`,
    },
}));
function RedErrorMessageBox({ children, }) {
    const { classes } = useStyles();
    return react_1.default.createElement("div", { className: classes.bg }, children);
}
